import { DeleteCourseType } from "../../../types/Course";
import { del } from "../../../utils/axios-config";
import { COURSES } from "../../../utils/constants";

export const deleteCourse = async (data: DeleteCourseType) => await del<DeleteCourseType, boolean>(COURSES, data);